import './patient-reminders-list.scss';

import { ReminderList } from '../../compositions/reminders/list/reminder-list';
import { BaseReminderItemDataFragment } from '../../data/types/api/graphql';

export type PatientReminderListProps = {
  items: BaseReminderItemDataFragment[];
  loading?: boolean;
  onClick?: (value: BaseReminderItemDataFragment) => void;
};

export function PatientRemindersList({
  items,
  loading,
  onClick,
}: PatientReminderListProps) {
  return (
    <div className="patient-reminders-list">
      <ReminderList loading={loading} items={items} onClick={onClick} />
    </div>
  );
}
